import React, { useMemo } from "react";
import { Card, Col, Placeholder } from "react-bootstrap";
import ReactApexChart from "react-apexcharts";
import { useFetchAbsencesQuery } from "features/absences/absenceSlice";

const MONTHS = [
  "Jan", "Fév", "Mar", "Avr", "Mai", "Juin",
  "Juil", "Août", "Sep", "Oct", "Nov", "Déc",
];

const AbsencesChart = () => {
  const { data: absences = [], isLoading, isError } = useFetchAbsencesQuery();

  const { categories, series } = useMemo(() => {
    const currentYear = new Date().getFullYear();
    const monthlyCounts = new Array(12).fill(0);

    absences.forEach((a) => {
      if (!a.date) return;
      const d = new Date(a.date);
      if (d.getFullYear() === currentYear) {
        monthlyCounts[d.getMonth()] += a.eleves?.length || 0;
      }
    });

    const currentMonth = new Date().getMonth();
    const cats = MONTHS.slice(0, currentMonth + 1);
    const data = monthlyCounts.slice(0, currentMonth + 1);

    return {
      categories: cats,
      series: [{ name: "Absences", data }],
    };
  }, [absences]);

  const options: ApexCharts.ApexOptions = {
    chart: {
      height: 300,
      type: "area",
      toolbar: { show: false },
      zoom: { enabled: false },
    },
    colors: ["#e74c3c"],
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        type: "vertical",
        opacityFrom: 0.4,
        opacityTo: 0.05,
        stops: [0, 90, 100],
      },
    },
    stroke: { width: 2.5, curve: "smooth" },
    dataLabels: { enabled: false },
    xaxis: { categories },
    yaxis: {
      title: { text: "Nombre d'absences" },
      min: 0,
    },
    grid: {
      borderColor: "#f1f1f1",
      strokeDashArray: 4,
    },
    markers: {
      size: 4,
      colors: ["#fff"],
      strokeColors: "#e74c3c",
      strokeWidth: 2,
      hover: { size: 6 },
    },
    tooltip: {
      y: { formatter: (val: number) => `${val} absence${val > 1 ? "s" : ""}` },
    },
  };

  return (
    <Col xxl={6} lg={12}>
      <Card>
        <Card.Header>
          <h5 className="card-title mb-0">
            <i className="ri-line-chart-line me-2 text-danger" />
            Évolution des absences {new Date().getFullYear()}
          </h5>
        </Card.Header>
        <Card.Body>
          {isLoading ? (
            <Placeholder as="div" animation="glow">
              <Placeholder xs={12} style={{ height: 300 }} />
            </Placeholder>
          ) : isError ? (
            <div className="text-center text-danger py-5">
              <i className="ri-error-warning-line fs-1 d-block mb-2" />
              Impossible de charger les données
            </div>
          ) : (
            <ReactApexChart
              options={options}
              series={series}
              type="area"
              height={300}
            />
          )}
        </Card.Body>
      </Card>
    </Col>
  );
};

export default AbsencesChart;
